import { Component, OnInit, Inject, ChangeDetectorRef, Input } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";

@Component({
  selector: 'app-loader-dialog',
  templateUrl: './loader-dialog.component.html',
  styleUrls: ['./loader-dialog.component.css']
})
export class LoaderDialogComponent implements OnInit {

  @Input() loading: boolean;

  header: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private cdf: ChangeDetectorRef,
    public dialogRef: MatDialogRef<LoaderDialogComponent>
  ) {
    this.header = data.header;
    this.loading = data.loading;
    setTimeout(() => {
      this.loaderCheck();
    }, 1000);
  }

  ngOnInit(): void {
  }

  loaderCheck(): void {
    if (!this.loading) {
      setTimeout(() => {
        this.dialogRef.close();
      }, 1000);
    } else {

      setTimeout(() => {
        this.loaderCheck();
      }, 1000);
    }
  }

}
